"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/APIKeys/AccountAPIKeys.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _org = require('shared/selectors/org');
var _hooks = require('web/services/hooks');
var _hooks3 = require('./hooks');

var _ = require('.'); var _2 = _interopRequireDefault(_);





const AccountAPIKeys = ({ account }) => {
  const { DefaultOrgKey, OrgKeys } = account
  const storeOrgs = _hooks.useAppSelector.call(void 0, _org.selectOrgs)
  const orgs = _react.useMemo.call(void 0, 
    () => OrgKeys.map(OrgKey => ({ OrgKey, Name: _nullishCoalesce(_optionalChain([storeOrgs, 'access', _3 => _3[OrgKey], 'optionalAccess', _4 => _4.Name]), () => ( 'Organization')) })),
    [OrgKeys, storeOrgs],
  )
  const apiKeys = _hooks3.useAccountAPIKeys.call(void 0, DefaultOrgKey)

  return (
    _react2.default.createElement(_2.default, {
      orgKey: DefaultOrgKey,
      orgs: orgs,
      keys: _nullishCoalesce(_optionalChain([apiKeys, 'access', _5 => _5.list, 'optionalAccess', _6 => _6.Keys]), () => ( null)),
      apiAccess: _nullishCoalesce(_optionalChain([apiKeys, 'access', _7 => _7.list, 'optionalAccess', _8 => _8.APIAccess]), () => ( null)),
      hasLoadFailed: apiKeys.hasLoadFailed,
      onKeyChanged: apiKeys.onKeyChanged,
      onKeyCreated: apiKeys.onKeyCreated, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
    )
  )
}

exports. default = AccountAPIKeys
